import { IObjProps } from 'shared/consts/types';

import { RootState } from 'store/rootReducer';

export const customDashboardNameSelector = (state: RootState): string => state.Analytics.customDashboardName;
export const dashboardsSelector = (state: RootState): Array<IObjProps> => state.Analytics.dashboards.data;
